import { Card as CardEl, theme, Button, Stack } from '@veeqo/ui';
import { VeeqoSubtitle } from '../../Subtitles/VeeqoSubtitle';
import { Alert } from '../../Alert/Alert';
import { ContentType, ErrorType, copy } from '../../../content';
import { Progress } from '../../Progress/Progress';

export type CardVariant = 'default' | 'modal' | 'none';

const openTab = (url: string) => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const ModalCard = ({
  error,
  ready,
  jobId,
  contentType,
}: {
  error?: ErrorType;
  ready?: boolean;
  jobId?: string;
  contentType: ContentType;
}) => (
  <CardEl
    style={{
      marginTop: '7.75rem',
      width: '50%',
      borderRadius: theme.sizes[8],
      minHeight: '340px',
      maxWidth: '550px',
    }}
    renderFooter={() => (
      <Stack direction="horizontal" style={{ justifyContent: 'space-between' }}>
        <Button onClick={() => openTab(copy[contentType].termsUrl)}>
          {copy[contentType].termsText}
        </Button>
        <Button onClick={() => openTab(copy[contentType].privacyUrl)}>
          {copy[contentType].privacyText}
        </Button>
      </Stack>
    )}
  >
    <VeeqoSubtitle contentType={contentType} />
    {!error && !ready && (
      <Progress contentType={contentType} loadingColor={theme.colors.secondary.blue.base} />
    )}
    {error && <Alert contentType={contentType} errorKey={error} jobId={jobId} />}
    {ready && <span style={{ marginTop: theme.sizes.md, display: 'block', minHeight: '5.5rem' }} />}
  </CardEl>
);
